import React from "react";
import {
  Box,
  Table,
  Paper,
  styled,
  Button,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  TableContainer,
  Chip,
} from "@material-ui/core";

import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import { colors } from "../../utilities/src/Colors";

import BannerListController, {
  S,
  Props,
  IBannerItem,
} from "./BannerListController.web";

const Strings = {
  pageTitle: "Banners",
  noRecordFounds: "No Banners Found",
};

export default class BannerList extends BannerListController {
  constructor(props: Props) {
    super(props);
    this.state = {
      bannerList: [],
      isLoading: false,
    } as S;
  }

  render() {
    const { bannerList, isLoading } = this.state;

    return (
      <MainBoxWrapper>
        <Box className="pageWrapper" style={{ paddingTop: "10px" }}>
          <div style={webStyle.headerWrapper}>
            <PageTitle>{Strings.pageTitle}</PageTitle>
            <Button
              data-test-id="addBannerButton"
              className="addButton"
              onClick={() => this.props.navigation.navigate("BannerCreate")}
            >
              Add Banner
            </Button>
          </div>

          <TableContainer component={Paper} className="flexItem">
            <Table style={webStyle.table} aria-label="banners table">
              <TableHead className="stickyHeader">
                <TableRow style={{ background: "#204B9C", color: "#FFFFFF" }}>
                  <StyledHeaderCell>Title</StyledHeaderCell>
                  <StyledHeaderCell>Status</StyledHeaderCell>
                  <StyledHeaderCell>Position</StyledHeaderCell>
                  <StyledHeaderCell>Navigable</StyledHeaderCell>
                  <StyledHeaderCell>Navigation Type</StyledHeaderCell>
                  <StyledHeaderCell>Start Date</StyledHeaderCell>
                  <StyledHeaderCell>End Date</StyledHeaderCell>
                  <StyledHeaderCell>Image (EN)</StyledHeaderCell>
                  <StyledHeaderCell>Image (AR)</StyledHeaderCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!isLoading &&
                  bannerList.map((item: IBannerItem) => {
                    const attr = item.attributes;
                    return (
                      <TableRow key={item.id} data-test-id={"banner-row-" + item.id}>
                        <TableCell>{attr.title}</TableCell>
                        <TableCell>
                          <Chip
                            label={attr.is_active ? "Active" : "Inactive"}
                            style={{
                              backgroundColor: attr.is_active ? "#E8F5E9" : "#FFEBEE",
                              color: attr.is_active ? "#2E7D32" : "#C62828",
                              fontWeight: 600,
                            }}
                          />
                        </TableCell>
                        <TableCell>{attr.position}</TableCell>
                        <TableCell>{attr.is_navigable ? "Yes" : "No"}</TableCell>
                        <TableCell>{attr.navigation_type || "-"}</TableCell>
                        <TableCell>
                          {attr.start_date
                            ? new Date(attr.start_date).toLocaleDateString()
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {attr.end_date
                            ? new Date(attr.end_date).toLocaleDateString()
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {attr.image_en_url ? (
                            <img
                              src={attr.image_en_url}
                              alt="EN"
                              style={webStyle.thumbnail}
                            />
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell>
                          {attr.image_ar_url ? (
                            <img
                              src={attr.image_ar_url}
                              alt="AR"
                              style={webStyle.thumbnail}
                            />
                          ) : (
                            "-"
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>

              {isLoading && (
                <>
                  {Array(5)
                    .fill(1)
                    .map((_, index) => (
                      <TableBody key={index}>
                        <TableRow>
                          {[...Array(9)].map((_, cellIndex) => (
                            <TableRowsSkeleton key={cellIndex} />
                          ))}
                        </TableRow>
                      </TableBody>
                    ))}
                </>
              )}
            </Table>

            {bannerList.length === 0 && !isLoading && (
              <NoRecordFoundText>{Strings.noRecordFounds}</NoRecordFoundText>
            )}
          </TableContainer>
        </Box>
      </MainBoxWrapper>
    );
  }
}

// Customizable Area Start
const NoRecordFoundText = styled("div")({
  fontSize: 16,
  fontWeight: 600,
  textAlign: "center",
  padding: "40px 0",
});

const PageTitle = styled("div")({
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "29px",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "16px",
  },
});

const StyledHeaderCell = styled(TableCell)({
  color: "#FFFFFF !important",
  fontWeight: 600,
  fontFamily: "Montserrat",
});

const MainBoxWrapper = styled("div")({
  "& .MuiTableCell-root": {
    padding: "8px 12px !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
  },
  "& .MuiTableRow-root": {
    height: "48px",
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    padding: "10px 12px !important",
    fontWeight: 600,
    color: "#FFFFFF",
  },
  "& .stickyHeader": {
    zIndex: 2,
  },
  "& .addButton": {
    background: colors().cyancobaltblue,
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: colors().white,
    height: "56px",
    width: "184px",
    borderRadius: "8px",
    textTransform: "unset",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "13px",
      width: "160px",
      height: "44px",
    },
  },
});

const webStyle = {
  table: {
    minWidth: 700,
  },
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 32,
    alignItems: "center",
    flexWrap: "wrap" as "wrap",
  },
  thumbnail: {
    width: 60,
    height: 40,
    objectFit: "cover" as "cover",
    borderRadius: 4,
  },
};
// Customizable Area End
